var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71 11.5C4.71 9.961 5.961 8.71 7.5 8.71H11.1V7H7.5C5.016 7 3 9.016 3 11.5C3 13.984 5.016 16 7.5 16H11.1V14.29H7.5C5.961 14.29 4.71 13.039 4.71 11.5ZM8.4 12.4H15.6V10.6H8.4V12.4ZM16.5 7H12.9V8.71H16.5C18.039 8.71 19.29 9.961 19.29 11.5C19.29 13.039 18.039 14.29 16.5 14.29H12.9V16H16.5C18.984 16 21 13.984 21 11.5C21 9.016 18.984 7 16.5 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "97120/static/media/url.846983ef4bebe147356458e1d33cf0a0.svg";
export { ForwardRef as ReactComponent };